/**
 * Product Add-ons: aggiunge al carrello il prodotto principale + i prodotti add-on selezionati (checkbox).
 * Intercetta l'invio del form prodotto quando è presente la sezione add-on.
 */
(function () {
  function getAddonVariantIds() {
    const container = document.querySelector('[data-product-addons]');
    if (!container) return [];
    const checked = container.querySelectorAll('.product-addons__checkbox:checked');
    return Array.from(checked).map((el) => el.getAttribute('data-variant-id')).filter(Boolean);
  }

  function getProductForm() {
    const productForm = document.querySelector('product-form');
    return productForm ? productForm.querySelector('form[data-type="add-to-cart-form"]') : null;
  }

  function addToCart(bodyFormData, extra) {
    const config = window.fetchConfig ? window.fetchConfig('javascript') : {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    };
    delete config.headers['Content-Type'];
    config.body = bodyFormData;
    if (extra && extra.sections) {
      bodyFormData.append('sections', extra.sections);
      bodyFormData.append('sections_url', extra.sections_url || window.location.pathname);
    }
    return fetch(window.routes?.cart_add_url || '/cart/add.js', config).then((r) => r.json());
  }

  function init() {
    const form = getProductForm();
    const addonsContainer = document.querySelector('[data-product-addons]');
    if (!form || !addonsContainer) return;

    form.addEventListener(
      'submit',
      function (evt) {
        const addonIds = getAddonVariantIds();
        if (addonIds.length === 0) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        const submitButton = form.querySelector('[type="submit"]');
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const formData = new FormData(form);
        let sectionsForLast;
        if (cart && typeof cart.getSectionsToRender === 'function') {
          const sections = cart.getSectionsToRender();
          const sectionIds = sections.map((s) => s.section || s.id).filter(Boolean);
          if (sectionIds.length) sectionsForLast = { sections: sectionIds.join(','), sections_url: window.location.pathname };
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        if (submitButton) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
          const spinner = form.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }

        const isLastAddon = (index) => index === addonIds.length - 1;
        let chain = addToCart(formData, addonIds.length === 0 ? sectionsForLast : null);

        addonIds.forEach((variantId, index) => {
          chain = chain.then((prevResponse) => {
            if (prevResponse && prevResponse.status && prevResponse.status !== 200) return Promise.reject(prevResponse);
            const fd = new FormData();
            fd.append('id', variantId);
            fd.append('quantity', 1);
            return addToCart(fd, isLastAddon(index) ? sectionsForLast : null);
          });
        });

        chain
          .then((lastResponse) => {
            if (lastResponse && lastResponse.status && lastResponse.status !== 200) {
              if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
                window.publish(window.PUB_SUB_EVENTS.cartError, {
                  source: 'product-addons',
                  errors: lastResponse.description || lastResponse.message,
                  message: lastResponse.description || lastResponse.message,
                });
              }
              const errEl = form.querySelector('.product-form__error-message');
              if (errEl) {
                errEl.textContent = lastResponse.description || lastResponse.message || 'Errore nell\'aggiunta al carrello';
                const wrapper = form.querySelector('.product-form__error-message-wrapper');
                if (wrapper) wrapper.hidden = false;
              }
              return;
            }
            if (cart && typeof cart.renderContents === 'function' && lastResponse && lastResponse.sections) {
              cart.renderContents(lastResponse);
            } else if (window.routes && window.routes.cart_url) {
              window.location.href = window.routes.cart_url;
            }
          })
          .catch((err) => {
            console.error('Product addons:', err);
            const errEl = form.querySelector('.product-form__error-message');
            if (errEl && err && (err.description || err.message)) {
              errEl.textContent = err.description || err.message;
              const wrapper = form.querySelector('.product-form__error-message-wrapper');
              if (wrapper) wrapper.hidden = false;
            } else if (window.routes && window.routes.cart_url) {
              window.location.href = window.routes.cart_url;
            }
          })
          .finally(() => {
            if (submitButton) {
              submitButton.removeAttribute('aria-disabled');
              submitButton.classList.remove('loading');
              const spinner = form.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
            }
          });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
